/**
 * Regional shop groups used by the General Overview quick-select pool.
 *
 * Confirmed by the GM. This is intentionally **not** a partition: Radu covers
 * Amsterdam CS (`003`) and Eindhoven (`022`) in addition to Nacho and Matteo,
 * so those two shops appear in more than one region. All other shops belong to
 * exactly one manager. Codes (not IDs) keep it readable.
 *
 * Charlie — Amsterdam Zuid/Centrum + Haarlem (Kruisstraat)
 * Matteo  — Den Haag, Rotterdam and Eindhoven
 * Brenda  — Utrecht, Den Haag and Amsterdam
 * Radu    — Amsterdam CS + Eindhoven (overlapping coverage)
 * Nacho   — Amsterdam (Febo, Kinker, NDSM, Haarlemmerstraat, CS)
 */
export interface ShopRegion {
  key: string
  name: string
  storeCodes: string[]
}

export const SHOP_REGIONS: ShopRegion[] = [
  {
    key: 'charlie',
    name: 'Charlie',
    // Zuid, Claude, Haarlem (Kruisstraat), Reguliers.
    storeCodes: ['001', '008', '013', '020'],
  },
  {
    key: 'matteo',
    name: 'Matteo',
    // Lange Poten, Rijnstraat, Stadhuisplein, Rotterdam CS, Eindhoven.
    storeCodes: ['006', '007', '016', '018', '022'],
  },
  {
    key: 'brenda',
    name: 'Brenda',
    // Utrecht CS, Stadskamer, Batavia, Zwanestraat, Bijlmerplein.
    storeCodes: ['005', '011', '012', '017', '021'],
  },
  {
    key: 'radu',
    name: 'Radu',
    // Amsterdam CS + Eindhoven (intentional overlap with Nacho and Matteo).
    storeCodes: ['003', '022'],
  },
  {
    key: 'nacho',
    name: 'Nacho',
    // Febo (Ferdinand Bolstraat), Kinker, NDSM, Haarlemmerstraat, Amsterdam CS.
    storeCodes: ['002', '003', '004', '015', '019'],
  },
]
